




























import { Component, Prop, Vue } from 'vue-property-decorator'
import TrackResponse from '../../../types/TrackResponse'
import SearchConverter from '@/components/party/search/SearchConverter'

@Component
export default class SubSearchDisplayer extends Vue {
  @Prop() track!: TrackResponse
  @Prop() addTrack!: Function

  displayArtists (artists: Array<string>): string {
    return SearchConverter.convertArtistNamesToString(artists)
  }
}
